import React from "react";
import PropTypes from "prop-types";
import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import getStyles from "src/styles/whatsappStyles";
import { Iconify } from "src/components";

const MediaDisplayComponent = props => {
    const theme = useTheme();
    const { maxHeight, scrollToBottom, messageType, whatsAppMessageMedia: { whatsapp_media_mime_type: mediaType, media_file: fileDataUrl } } = props;
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(false);

    const handleLoad = () => {
        scrollToBottom();
        setLoading(false);
    };

    const handleError = () => {
        scrollToBottom();
        setError(true);
        setLoading(false);
    };

    const styles = getStyles(theme);

    // When media_file is null/empty, the backend hasn't downloaded the file yet.
    // Use messageType (from WhatsApp webhook) as fallback to show a helpful message.
    if (!fileDataUrl) {
        const typeLabel = messageType || mediaType?.split("/")?.[0] || "media";
        const iconMap = { image: "mdi:image-off-outline", video: "mdi:video-off-outline", audio: "mdi:microphone-off", document: "mdi:file-alert-outline" };
        const labelMap = { image: "Image", video: "Video", audio: "Audio", document: "Document" };
        return (
            <Box sx={{ display: "flex", alignItems: "center", gap: '6px', py: '4px' }}>
                <Iconify icon={iconMap[typeLabel] || "mdi:file-alert-outline"} sx={{ color: 'text.disabled', width: '1.2rem', height: '1.2rem' }} />
                <Typography sx={{ fontSize: '0.75rem', color: 'text.disabled', fontStyle: 'italic' }}>
                    {labelMap[typeLabel] || "Media"} not available
                </Typography>
            </Box>
        );
    }

    if (mediaType.includes("image/"))
        return <Box sx={{ maxWidth: "100%", minWidth: "3rem", display: "flex", cursor: "pointer", ...(maxHeight ? { maxHeight } : {}) }} onClick={() => window.open(fileDataUrl, "_blank")
        }>
            {loading && <Box sx={styles.imageLoadingBox}>
                <CircularProgress
                    size={20}
                /></Box>}
            {error && <Typography rel="noopener noreferrer" component={"a"} href={fileDataUrl} target="_blank" sx={styles.unsupportedMedia}>Unsupported Media (View)</Typography>}
            <img src={fileDataUrl}
                alt={`mediaType ${mediaType}`}
                onLoad={handleLoad}
                onError={handleError}
                style={{
                    display: loading ? "none" : "block",
                    width: "100%",
                    height: "auto",
                    objectFit: "contain",
                    ...(maxHeight ? { maxHeight } : {})
                }} />
        </Box >

    if (mediaType.includes("pdf")) {
        return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Iconify icon="bxs:file-pdf" sx={styles.mediaIcon} />
            <Typography component={"a"} rel="noopener noreferrer" href={fileDataUrl} target="_blank" sx={styles.unsupportedMedia}>View PDF</Typography>
        </Box>
    }
    if (mediaType.includes("audio")) {
        return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Iconify icon="bx:headphone" sx={styles.mediaIcon} />
            <Typography component={"a"} rel="noopener noreferrer" href={fileDataUrl} target="_blank" sx={styles.unsupportedMedia}>Listen Audio</Typography>
        </Box>
    }
    if (mediaType.includes("video")) {
        return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Iconify icon="entypo:video" sx={styles.mediaIcon} />
            <Typography component={"a"} rel="noopener noreferrer" href={fileDataUrl} target="_blank" sx={styles.unsupportedMedia}>View Video</Typography>
        </Box>
    }
    return <Typography component={"a"} rel="noopener noreferrer" href={fileDataUrl} target="_blank" sx={styles.unsupportedMedia}>Unsupported Media (View)</Typography>
};

export default MediaDisplayComponent;

MediaDisplayComponent.defaultProps = {
    whatsAppMessageMedia: {
        "whatsapp_media_file_size": 0,
        "whatsapp_media_mime_type": "",
        "media_file": "",
        "id": -1,
    },
    scrollToBottom: () => { },
    maxHeight: ""
}

MediaDisplayComponent.propTypes = {
    whatsAppMessageMedia: PropTypes.object,
    scrollToBottom: PropTypes.func,
    maxHeight: PropTypes.string,
    messageType: PropTypes.string,
}